import { post } from '../api';

const postCandidateSendRehostMessage = (candidateId) =>
  post(`/candidates/${candidateId}/send_rehost_message`);

export default postCandidateSendRehostMessage;
